module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/3/5-3115d170b24e62c86536bbfed8c2aea2.jpg";